/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Spin } from 'antd';
import capitalize from 'lodash/capitalize';

import { useAthletesByIds, useDisciplinesByIds, useCompetitionsByIds, useEventsByIds } from '@api/hooks';
import * as mediaUtils from '@utils/media';
import * as queryUtils from '@utils/query';
import { Button } from '@atoms';
import { TextField, MediaLibraryModal } from '@molecules';
import { MEDIA_TYPE } from '@api/media/constants';

import Form from '../Form';
import RelatedContentField from '../RelatedContentField';
import { FORM_FIELD, FORM_FIELDS } from './constants';

const MediaDetailsForm = ({ file, media, form, onReupload }) => {
  const { fileName, src, type, typeName } = mediaUtils.getInfo({ file, media, thumbnail: true });

  const athletesQuery = useAthletesByIds(
    media?.relatedAthleteIds,
    queryUtils.withUpdateForm({ form, field: FORM_FIELD.RELATED_ATHLETES }),
  );
  const disciplinesQuery = useDisciplinesByIds(
    media?.relatedDisciplineIds,
    queryUtils.withUpdateForm({ form, field: FORM_FIELD.RELATED_DISCIPLINES }),
  );
  const competitionsQuery = useCompetitionsByIds(
    media?.relatedCompetitionIds,
    queryUtils.withUpdateForm({ form, field: FORM_FIELD.RELATED_COMPETITIONS }),
  );
  const eventsQuery = useEventsByIds(
    media?.relatedEventIds,
    queryUtils.withUpdateForm({ form, field: FORM_FIELD.RELATED_EVENTS }),
  );

  const allQueries = [athletesQuery, disciplinesQuery, competitionsQuery, eventsQuery];
  const isFetching = queryUtils.isAnyQueryFetching(allQueries);
  // TODO: show error when error block is integrated in modal
  // const queryError = queryUtils.getAnyQueryError(allQueries);

  const initialValues = React.useMemo(() => form.deserialize(media), [media, form]);

  return (
    <>
      <Spin spinning={isFetching}>
        <MediaLibraryModal.Heading>
          <MediaLibraryModal.Title
            subtitle={file && fileName}
            extra={type === MEDIA_TYPE.IMAGE && <MediaLibraryModal.HeroImage src={src} />}
          >
            {capitalize(typeName)} details
          </MediaLibraryModal.Title>
        </MediaLibraryModal.Heading>
        {media && (
          <Button type="customBlue" onClick={onReupload} style={{ marginBottom: 30 }}>
            REUPLOAD {typeName.toUpperCase()}
          </Button>
        )}
        {type === MEDIA_TYPE.DOCUMENT && src && (
          <Button type="link" href={src} target="_blank" rel="noopener noreferrer">
            open document
          </Button>
        )}
        <Form form={form} layout="vertical" initialValues={initialValues}>
          <TextField {...FORM_FIELD.TITLE} />
          <TextField {...FORM_FIELD.COPYRIGHT} />
          <RelatedContentField form={form} fields={FORM_FIELDS} />
        </Form>
      </Spin>
    </>
  );
};

export default MediaDetailsForm;
